/*!

=========================================================
* Argon Design System React - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss?v1.1.0";

import Landing from "views/examples/Landing.js";
import DataAnalytics from "views/examples/DataAnalytics.js";
import DataConsulting from "views/examples/DataConsulting.js";
import IoTPlatform from "views/examples/IoTPlatform.js";
import IndustrialSolutions from "views/examples/IndustrialSolutions.js";
import HomeSolutions from "views/examples/HomeSolutions.js";
import About from "views/examples/About.js";
import Contact from "views/examples/Contact.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename="/portal">
    <Switch>
      <Route
        path="/consulting"
        exact
        render={(props) => <DataConsulting {...props} />}
      />
      <Route
        path="/platform"
        exact
        render={(props) => <IoTPlatform {...props} />}
      />
      <Route
        path="/data-analytics"
        exact
        render={(props) => <DataAnalytics {...props} />}
      />
      <Route
        path="/industrial"
        exact
        render={(props) => <IndustrialSolutions {...props} />}
      />
      <Route
        path="/home"
        exact
        render={(props) => <HomeSolutions {...props} />}
      />
      <Route
        path="/about"
        exact
        render={(props) => <About {...props} />}
      />
      <Route
        path="/contact"
        exact
        render={(props) => <Contact {...props} />}
      />
      <Route
        path="/"
        exact
        render={(props) => <Landing {...props} />}
      />
      <Redirect to="/" />
    </Switch>
  </BrowserRouter>
);
